import { useQuery } from 'react-query';
import api from '../utils/api';

// Personal taste memory: the songs this user reaches for at every party.
// Server-side profile built from their suggestions and upvotes — works
// for anonymous guests too.
export const useGoTos = (enabled = true) => {
  return useQuery(
    ['goTos'],
    async () => {
      const response = await api.get('/api/users/me/taste');
      return response.data.goTos || [];
    },
    {
      enabled,
      staleTime: 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      retry: 0
    }
  );
};
